module.exports = __webpack_public_path__ + "img/znt1.07a588c0.png";